{
  "name": "mypbconnect",
  "version": "1.6.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --configuration=development --o",
    "build": "ng build",
    "build:qa": "ng build --configuration qa",
    "build:production": "ng build --configuration production",
    "build:development": "ng build --configuration development",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix",
    "style:lint": "npx stylelint  \"**/*.{css,scss}\"",
    "style:fix": "npx stylelint  \"**/*.{css,scss}\" --fix",
    "format:check": "npx prettier --check .",
    "format:fix": "npx prettier --write .",
    "install:packages": "pnpm i",
    "test": "pnpm vitest run",
    "test:coverage": "pnpm vitest run --coverage --no-file-parallelism",
    "e2e:run": "ts-node ./playwright/start.ts email=endtoend@dev-mypbconnect.com",
    "e2e:open": "ts-node ./playwright/start.ts --open email=endtoend@dev-mypbconnect.com",
    "e2e:open:dev": "ts-node ./playwright/start.ts --open email=endtoend@dev-mypbconnect.com url=https://www.a16.dev-mypbconnect.com",
    "e2e:run:dev": "ts-node ./playwright/start.ts email=endtoend@dev-mypbconnect.com url=https://www.a16.dev-mypbconnect.com",
    "analyze": "ng build --stats-json --output-path=dist && webpack-bundle-analyzer dist/stats.json",
    "deps:licenses": "pnpm list --depth 0 --json --prod --long > src/assets/data/licenses.json"
  },
  "lint-staged": {
    "*.{css,scss}": "stylelint",
    "*.{js,ts,json,md,html,css,scss}": "prettier --write"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "21.2.10",
    "@angular/cdk": "21.2.8",
    "@angular/common": "21.2.10",
    "@angular/compiler": "21.2.10",
    "@angular/core": "21.2.10",
    "@angular/forms": "21.2.10",
    "@angular/localize": "21.2.10",
    "@angular/material": "21.2.8",
    "@angular/material-luxon-adapter": "21.2.8",
    "@angular/platform-browser": "21.2.10",
    "@angular/router": "21.2.10",
    "@fontsource/caveat": "5.3.0",
    "@fontsource/dancing-script": "5.3.0",
    "@fontsource/great-vibes": "5.3.0",
    "@fontsource/pacifico": "5.3.0",
    "@fontsource/satisfy": "5.3.0",
    "@ng-bootstrap/ng-bootstrap": "20.0.0",
    "@ng-select/ng-select": "21.8.0",
    "@ngx-loading-bar/core": "7.0.1",
    "@ngx-loading-bar/http-client": "7.0.1",
    "@ngx-translate/core": "17.0.0",
    "@ngx-translate/http-loader": "17.0.0",
    "@pb-design-system/pb-design-system": "19.0.0-beta.0",
    "@popperjs/core": "2.11.8",
    "amazon-cognito-identity-js": "6.3.16",
    "amazon-quicksight-embedding-sdk": "2.11.3",
    "bootstrap": "5.3.8",
    "buffer": "6.0.3",
    "chardet": "2.1.1",
    "chart.js": "4.5.1",
    "chartjs-plugin-datalabels": "2.2.0",
    "detect-file-encoding-and-language": "2.4.0",
    "docxtemplater": "3.68.5",
    "file-saver": "2.0.5",
    "html2canvas": "1.4.1",
    "iconv-lite": "0.7.2",
    "jschardet": "3.1.4",
    "jspdf": "4.2.1",
    "jspdf-autotable": "5.0.7",
    "jszip": "3.10.1",
    "lodash-es": "4.18.1",
    "luxon": "3.7.2",
    "material-icons": "1.13.14",
    "ng-dynamic-component": "10.8.2",
    "ng2-charts": "10.0.0",
    "ngx-color-picker": "20.1.1",
    "ngx-csv": "0.3.2",
    "ngx-file-drop": "16.0.0",
    "ngx-font-picker": "20.1.0",
    "ngx-infinite-scroll": "21.0.0",
    "ngx-quill": "^30.1.3",
    "ngx-toastr": "20.0.5",
    "papaparse": "5.5.3",
    "pdf-lib": "1.17.1",
    "pdfjs-dist": "5.6.205",
    "pdfobject": "2.3.1",
    "pizzip": "3.2.0",
    "postal-codes-js": "2.5.2",
    "postal-mime": "2.7.4",
    "primeflex": "4.0.0",
    "primeicons": "7.0.0",
    "primeng": "21.1.6",
    "qrcode": "1.5.4",
    "quill": "^2.0.3",
    "rxjs": "7.8.2",
    "sass": "1.99.0",
    "tesseract.js": "7.0.0",
    "tesseract.js-core": "7.0.0",
    "tslib": "2.8.1",
    "uuid": "14.0.0",
    "zone.js": "0.16.1"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "2.6.1",
    "@analogjs/vitest-angular": "2.6.1",
    "@angular-devkit/build-angular": "21.2.8",
    "@angular-eslint/builder": "21.4.0",
    "@angular-eslint/eslint-plugin": "21.4.0",
    "@angular-eslint/eslint-plugin-template": "21.4.0",
    "@angular-eslint/template-parser": "21.4.0",
    "@angular/cli": "21.2.8",
    "@angular/compiler-cli": "21.2.10",
    "@commitlint/cli": "20.5.0",
    "@commitlint/config-conventional": "20.5.0",
    "@eslint/js": "10.0.1",
    "@playwright/test": "1.61.1",
    "@types/file-saver": "2.0.7",
    "@types/lodash-es": "4.17.12",
    "@types/luxon": "3.7.1",
    "@types/node": "25.6.0",
    "@types/offscreencanvas": "2019.7.3",
    "@types/qrcode": "1.5.6",
    "@vitest/coverage-v8": "4.0.4",
    "@vitest/ui": "4.0.4",
    "eslint": "10.6.0",
    "eslint-config-prettier": "10.1.8",
    "husky": "9.1.7",
    "jsdom": "29.1.1",
    "lint-staged": "16.4.0",
    "prettier": "3.8.3",
    "stylelint": "17.9.0",
    "stylelint-config-standard-scss": "17.0.0",
    "ts-node": "10.9.2",
    "typescript": "5.9.3",
    "typescript-eslint": "8.63.0",
    "vitest": "4.0.4"
  }
}
